import { useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import Modal from "../../layouts/Modal";
import NotesOutput from "../shared/Notes/NotesOutput";
import { IPart } from "../../models/Part";
import { INote, ResourceType } from "../../models/Note";
import useNotes from "../../data/useNotes";

export default function PartNotesModal({ 
  open, 
  setOpen, 
  part
}: { 
  open: boolean, 
  setOpen: React.Dispatch<React.SetStateAction<boolean>>, 
  part: IPart | undefined
}) {
  const { useNotesByResource } = useNotes();
  const { data } = useNotesByResource(part?.id);

  const [notes, setNotes] = useState<INote[]>([]);

  useEffect(() => {
    if (!part) return;

    if (data && data.data) setNotes(data.data);
  }, [data, part]);

  if (!part) return <></>; 

  return (
    <Modal open={open} width={"max-w-6xl"} setOpen={setOpen}>
      <div>
        <h2 className="flex justify-between text-lg font-medium leading-6 text-gray-900 px-4">
          Part Condition Notes
        </h2>
        <small className="text-sm font-medium text-gray-500 mt-2 px-4">This will go onto the listing</small>
        
        <NotesOutput
          resourceId={part.id}
          resourceType={ResourceType.Part}
          shouldScroll={false}
          notes={notes.filter(note => note.resourceType === ResourceType.Part)}
          refetchQuery={["notes", part.id]}
        />

        <hr className="my-6" />

        <h2 className="flex justify-between text-lg font-medium leading-6 text-gray-900 px-4">
          Internal Part Notes
        </h2>
        
        <small className="text-sm font-medium text-gray-500 mt-2 px-4">This will not go onto the listing</small>
        
        <NotesOutput
          resourceId={part.id}
          resourceType={ResourceType.InternalPart}
          shouldScroll={false}
          notes={notes.filter(note => note.resourceType === ResourceType.InternalPart)}
          refetchQuery={["notes", part.id]}
        />
      </div>
    </Modal>
  )
}